import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "q-pa-md" }
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Ej åtkomst! ")
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "text-grey-8 text-h6 text-weight-regular" }, " Du har ej behörighet till sidan ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h4", _hoisted_2, [
      _createVNode(_component_q_icon, {
        name: "mdi-close-octagon-outline",
        class: "q-mr-sm"
      }),
      _hoisted_3
    ]),
    _hoisted_4
  ]))
}